import { render, staticRenderFns } from "./ScheduleCard.vue?vue&type=template&id=531956a3&scoped=true&"
import script from "./ScheduleCard.vue?vue&type=script&lang=ts&"
export * from "./ScheduleCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleCard.vue?vue&type=style&index=0&id=531956a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531956a3",
  null
  
)

export default component.exports